// Base URLs for the three hallpass-backend Cloud Run services.
//
// Required environment variables (CRA build-time, must be set in .env):
//   REACT_APP_USER_API_URL    - e.g. https://user-api-xxxxx.a.run.app
//   REACT_APP_SCHOOLS_API_URL - e.g. https://schools-api-xxxxx.a.run.app
//   REACT_APP_PASSES_API_URL  - e.g. https://passes-api-xxxxx.a.run.app
//
// These are consumed at build time by Create React App (any var prefixed
// with REACT_APP_ is inlined into the production bundle).

function requireApiBase(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing required environment variable ${name}. Set it in .env (see src/api/config.js for the full list of required API base URLs).`
    );
  }
  return value;
}

export const USER_API_BASE: string = requireApiBase(
  'REACT_APP_USER_API_URL',
  process.env.REACT_APP_USER_API_URL
);
export const SCHOOLS_API_BASE: string = requireApiBase(
  'REACT_APP_SCHOOLS_API_URL',
  process.env.REACT_APP_SCHOOLS_API_URL
);
export const PASSES_API_BASE: string = requireApiBase(
  'REACT_APP_PASSES_API_URL',
  process.env.REACT_APP_PASSES_API_URL
);
